import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../../../main-page/main-page.service';
import { PiperingFamilyManagmentComponent } from '../pipering-family-managment/pipering-family-managment.component';
import { PiperingFamilyModel } from '../../../../models/dictionaries/pipering-family.model';
declare var $: any;

@Component({
  selector: 'app-pipering-families-grid',
  template: `<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipering family?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deletePiperingFamily()">Delete</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!isPiperingFamilyChoosen">
    <div class="input-effect">
        <input class="effect1" type="text" placeholder="">
        <label>Search</label>
        <span class="focus-border"></span>
    </div>
    <button class="red-button" type="button" data-toggle="modal" data-target="#addModal" (click)="createNewPiperingFamily()">Create</button>

    <table>
        <tr>
            <th *ngFor="let header of headers">{{header}}</th>
        </tr>
        <tr *ngFor="let piperingFamily of piperingFamiliesGridData, let row_no = index">
            <td>{{piperingFamily.name}}</td>
            <td>{{piperingFamily.description}}</td>
            <td class="columnWithIcons">
                <button type="button" class="btn editBtn" (click)="editPiperingFamily(piperingFamily)">
                    <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(piperingFamily)">
                    <i class="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    </table>
</div>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class PiperingFamiliesGridComponent implements OnInit {
  @Input() managmentComponent: PiperingFamilyManagmentComponent;
  isPiperingFamiliesHidden = true;
  piperingFamiliesGridData: PiperingFamilyModel[];
  selectedPiperingFamily: PiperingFamilyModel;
  isPiperingFamilyChoosen: boolean = false;
  elementIndex: number;
  headers: string[] = ['Name', 'Description', ''];

  constructor(private mainPageService: MainPageService) { }

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deletePiperingFamilySubject.subscribe((value) => {
      this.piperingFamiliesGridData = this.piperingFamiliesGridData.filter(x => x._id !== value);
    });
    this.managmentComponent.stateSubject.subscribe((state) => {
      if (state !== null) {
        Object.assign(this.piperingFamiliesGridData[this.elementIndex], state);
      }
      this.isPiperingFamilyChoosen = false;
    })
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllPiperingFamilies().subscribe((response) => {
      this.piperingFamiliesGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
      $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isPiperingFamiliesHidden = !this.isPiperingFamiliesHidden;
  }

  createNewPiperingFamily() {
    const piperingFamily = new PiperingFamilyModel();
    this.mainPageService.addNewPiperingFamilyIntoDb(JSON.stringify(piperingFamily)).subscribe((response) => {
      piperingFamily._id = response._id;
      piperingFamily.id = response.id;
      this.piperingFamiliesGridData.push(piperingFamily);
      this.elementIndex = this.piperingFamiliesGridData.indexOf(piperingFamily);
      this.managmentComponent.showManagmentPage(piperingFamily, true);
    });
    this.isPiperingFamilyChoosen = true;
  }

  setChoosenElement(element) {
    this.selectedPiperingFamily = {
      ...element,
    };
    this.elementIndex = this.piperingFamiliesGridData.indexOf(element);
  };

  editPiperingFamily(element) {
    this.selectedPiperingFamily = {
      ...element,
    };
    this.elementIndex = this.piperingFamiliesGridData.indexOf(element);
    this.managmentComponent.showManagmentPage(this.selectedPiperingFamily, false);
    this.isPiperingFamilyChoosen = true;
  }

  deletePiperingFamily() {
    this.mainPageService.removePiperingFamily(this.selectedPiperingFamily._id).subscribe((res) => { }, (error: any) => { });
    this.mainPageService.deletePiperingFamilySubject.next(this.selectedPiperingFamily._id);
  }
}
